/**
 * ReportDownloadButton Component
 * Placeholder component for report generation functionality
 */

import React from 'react';
import { Button } from '@mui/material';
import { Download } from '@mui/icons-material';

const ReportDownloadButton = ({ filmId, filmTitle, ...props }) => {
  return (
    <Button
      variant="outlined"
      startIcon={<Download />}
      size="small"
      disabled
      {...props}
    >
      Download Report
    </Button>
  );
};

export default ReportDownloadButton;
